import { FC } from 'react';
import { Stack } from 'rsuite';
import { SText } from '@setvi/shared/components';
import { AIIcon, ExportIcon } from '@setvi/shared/components/sicons';
import { AIGradientBgColor } from '@setvi/shared/components/intelligence/styled';
import { CSVLink } from 'react-csv';
import { EnhanceAllButton, ExportProductButton } from './styled';
import { useGradientBorderStyles } from '../../hooks/useGradientBorderStyles';
import { EnhancedFieldCsvRow } from '../../types';
import { isSyntheticEvent } from './helpers';

interface EnhancerHeaderProps {
  enhancedCsvData: EnhancedFieldCsvRow[];
  onExportClick?: () => void;
  enhanceAllLoading: boolean;
  onEnhanceAllClick?: () => void;
}

export const EnhancerHeader: FC<EnhancerHeaderProps> = ({
  onExportClick,
  enhancedCsvData,
  onEnhanceAllClick,
  enhanceAllLoading
}) => {
  const { buttonBorderGradientClass } = useGradientBorderStyles({
    gradient: 'enhanced',
    backgroundColor: AIGradientBgColor
  });

  // ! handlers
  const handleExportClick = (event: unknown) => {
    if (enhanceAllLoading && isSyntheticEvent(event)) {
      event.preventDefault();
      return;
    }

    onExportClick();
  };

  // ! render
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <SText title="Enhance Product" weight="semibold" />

      <Stack direction="row" spacing={12}>
        <CSVLink
          asyncOnClick
          data={enhancedCsvData}
          onClick={handleExportClick}
          filename="product.csv">
          <ExportProductButton
            variant="outlined"
            startIcon={<ExportIcon />}
            disabled={enhanceAllLoading}>
            Export This Product
          </ExportProductButton>
        </CSVLink>

        <EnhanceAllButton
          disabled={enhanceAllLoading}
          startIcon={<AIIcon fill="#fff" />}
          onClick={onEnhanceAllClick}
          className={buttonBorderGradientClass}>
          Enhance All Fields
        </EnhanceAllButton>
      </Stack>
    </Stack>
  );
};
